module.exports = __webpack_public_path__ + "static/0045-442bdffc6f41e4037f68020458c4d3fd.png";